import c from "../../../node_modules/linkify-it/index.mjs";
const o = new c();
function s(t) {
  const r = o.match(t);
  if (!r)
    return {
      type: "doc",
      content: [
        {
          type: "paragraph",
          content: [{ type: "text", text: t }]
        }
      ]
    };
  const i = [];
  let e = 0;
  for (const n of r)
    n.index > e && i.push({
      type: "text",
      text: t.slice(e, n.index)
    }), i.push({
      type: "text",
      text: n.raw,
      marks: [
        {
          type: "link",
          attrs: { href: n.url }
        }
      ]
    }), e = n.lastIndex;
  return e < t.length && i.push({
    type: "text",
    text: t.slice(e)
  }), {
    type: "doc",
    content: i
  };
}
export {
  s as linkifyPlainText
};
